import api from '@/services/api/audit.js'
import { immerable } from 'immer'
import { useState } from 'react'

class Audit {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.timestamp = params.timestamp
		this.type = params.type
		this.orgId = params.orgId
		this.content = params.content
		this.action = params.action
		this.page = params.page
		this.status = params.status
		this.remarks = params.remarks
		this.email = params.email
	}
}

const useAudit = () => {

	const [itemsAudit, setItemsAudit] = useState([])
	const [metaAudit, setMetaAudit] = useState(null)
	const [currentItemAudit ,setCurrentItemAudit] = useState(null)
	const [loadingAudit, setLoadingAudit] = useState(false)
	const [errorAudit, setErrorAudit] = useState()
	const [auditEnums] = useState([])

	async function fetchAudit(parameter) {
		if(loadingAudit){
			return
		}

		setLoadingAudit(true)

		const params = parameter ? parameter : "";

		const [error, response] = await api.index({
			params
		})
		setLoadingAudit(false)
		if (error) {
			return setErrorAudit(error)
		}

		const { items, meta } = response

		if (!Array.isArray(items)) {
			return setErrorAudit('Audit is not an array')
		}

		const serializedData = items.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new Audit(data))

		setMetaAudit(meta)
		setItemsAudit(newItems)
	}

	async function getAuditEnum() {

		setLoadingAudit(true)

		const [error, response] = await api.getAuditEnum()

		setLoadingAudit(false)

		if (error) {
			return setErrorAudit(error?.error?.mssage||'Get Audit Enum has error')
		}
		if (!response){
			return setErrorAudit(error?.error?.mssage || 'Audit Enum is empty ')
		}

		return response
	}


	async function findAudit(parameter) {

		setLoadingAudit(true)

		const params = parameter ? parameter : "";

		const [error, items] = await api.index({
			params
		})

		setLoadingAudit(false)

		if (error) {
			return setErrorAudit(error)
		}

		if (!Array.isArray(items)) {
			return setErrorAudit('Audit is not an array')
		}

		const serializedData = items.map(entry => serialize(entry))
		return serializedData.map(data => new Audit(data))
	}

	function serialize(entry) {
		return {
			id : entry.id,
			timestamp : entry.timestamp,
			type : entry.auditType,
			orgId: entry.orgId,
			content: entry.content,
			action: entry.auditAction,
			page: entry.auditPage,
			status : entry.auditStatus,
			remarks: entry.remarks,
			email: entry.email
		}
	}

	function viewAudit(id) {
		const newCurrentItem = itemsAudit.find(item => item.id === id)
		setCurrentItemAudit(newCurrentItem)
	}

	return {
		currentItemAudit,
		errorAudit,
		fetchAudit,
		itemsAudit,
		loadingAudit,
		metaAudit,
		setCurrentItemAudit,
		setItemsAudit,
		viewAudit,
		findAudit,
		getAuditEnum,
		auditEnums
	}

}

export default useAudit
